<div class="card mb-3">

    <div class="card-header">
        <span translate>contract.service.info</span>
    </div>

    <div class="card-body" *ngIf="_contracts?.length > 0">

        <custom-select #contractTypeSelect adaptive="true" title_multiple="contract.type" [values]="_contracts"
            [selectFirstById]="_guided_creation.pharmaId" (change)="contractChange($event)"></custom-select>
        <br>

        <ng-container *ngFor="let item of maxCounter">

            <mat-form-field>
                <mat-label translate>contract.service.name</mat-label>

                <ng-container [ngSwitch]="item">
                    <ng-container *ngSwitchCase="1"><input [(ngModel)]="_service.name1" matInput>
                    </ng-container>
                    <ng-container *ngSwitchCase="2"><input [(ngModel)]="_service.name2" matInput>
                    </ng-container>
                    <ng-container *ngSwitchCase="3"><input [(ngModel)]="_service.name3" matInput>
                    </ng-container>
                    <ng-container *ngSwitchCase="4"><input [(ngModel)]="_service.name4" matInput>
                    </ng-container>
                    <ng-container *ngSwitchCase="5"><input [(ngModel)]="_service.name5" matInput>
                    </ng-container>
                    <ng-container *ngSwitchCase="6"><input [(ngModel)]="_service.name6" matInput>
                    </ng-container>
                </ng-container>

            </mat-form-field>

            <hr>

        </ng-container>

        <br>

        <mat-checkbox [(ngModel)] = "_service.booking" *ngIf="canEnableBooking()">
            <span translate>contract.service.enable_booking</span>
            <button mat-icon-button [matTooltip] = "'contract.service.booking_info' | translate">
                <mat-icon>help_outline</mat-icon>
            </button>
        </mat-checkbox>
    </div>
</div>